import AbstractCountrySelect from './AbstractCountry';
import CountryNames from '../../helpers/countryNames';

const selectOptions = (function buildOptions() {
  const options = {};
  Object.assign(options, CountryNames);

  return Object
    .keys(options)
    .map(code => ({
      value: code,
      label: options[code]
    }));
})();

class CountrySelect extends AbstractCountrySelect {
  placeholder = "Select a country";
  name = "country-select-list";

  getOptions() {
    return selectOptions;
  }
}

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/components/Selects/Country.js